export default __webpack_public_path__ + "static/media/qr-code-scan-3.51571f6e.png";